import { t } from 'configs/i18n'

/**
 * @description Sets boolean values to string
 * @param {boolean} boolValue
 * @returns {string} value
 */
const parseBooleanValue = (boolValue: boolean): string => (boolValue ? t('yes') : '')

/**
 * @description Checks if a string value represents a "yes" response
 * @param {string | undefined} value
 * @returns {boolean} isYes
 */
const isYes = (value: string | undefined): boolean => value?.toLowerCase() === t('yes').toLowerCase()

export { parseBooleanValue, isYes }
